export function downloadFile(data, fileName){ // url name
    // 地址不存在时，禁止操作
    if(!data)return;
    // 下载文件并保存到本地
    const callback = (data)=>{
      // 创建a标签，使用 html5 download 属性下载，
      const link = document.createElement('a');
      // 创建url对象
      const objectUrl = window.URL.createObjectURL(new Blob([data]));
      link.style.display='none';
      link.href=objectUrl;
      // 自定义文件名称， fileName
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      // 适当释放url
      window.URL.revokeObjectURL(objectUrl);
    };
    // 把接口返回的url地址转换为 blob
    const xhr = new XMLHttpRequest();
    xhr.open('get', data, true);
    xhr.responseType = 'blob';
    xhr.onload = ()=> {
      // 返回文件流，进行下载处理
      callback(xhr.response);
    };
    xhr.send(); // 不要忘记发送
  }
//测试提交bug
export function exportFileDocument(data, fileName){ // url name
  let str = data;
  let lastIndex = str.lastIndexOf('.')
  let result = str.substr(lastIndex+1)
  // 地址不存在时，禁止操作
  if(!data)return;
  // 下载文件并保存到本地
  const callback = (data)=>{
    // 创建a标签，使用 html5 download 属性下载，
    const link = document.createElement('a');
    // 创建url对象
    const objectUrl = window.URL.createObjectURL(new Blob([data]));
    link.style.display='none';
    link.href=objectUrl;
    // 自定义文件名称， fileName
    link.download = fileName+result;
    document.body.appendChild(link);
    link.click();
    // 适当释放url
    window.URL.revokeObjectURL(objectUrl);
  };
  // 把接口返回的url地址转换为 blob
  const xhr = new XMLHttpRequest();
  xhr.open('get', data, true);
  xhr.responseType = 'blob';
  xhr.onload = ()=> {
    // 返回文件流，进行下载处理
    callback(xhr.response);
  };
  xhr.send(); // 不要忘记发送
}



// WEBPACK FOOTER //
// ./src/api/file.js